import { render, staticRenderFns } from "./InformationHome.vue?vue&type=template&id=b21227a6&scoped=true&"
import script from "./InformationHome.vue?vue&type=script&lang=js&"
export * from "./InformationHome.vue?vue&type=script&lang=js&"
import style0 from "./InformationHome.vue?vue&type=style&index=0&id=b21227a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21227a6",
  null
  
)

export default component.exports